

<template>
	<div class="big-button" v-bind:data-index="index" :class="{current:isCurrent}">
		<a @click="onClick" class="link pr-5 pl-3 py-2 mb-2" :class="{disabled:disabled}">
			<slot></slot>
		</a>
	</div>
</template>

<script>

import { EventBus } from '@/common/eventbus.js';
import { mapState } from 'vuex';

export default {
	props: ['disabled', 'link', 'index', 'node'],
	data: () => {
		return {
		}
	},
	computed: {
		...mapState('navigation', ['current']),
		isCurrent() {
			return this.current.url == this.link
		}
	},
	methods: {
		onClick() {
			EventBus.$emit('nav-clicked', {
				link: this.link,
				node: this.node,
			});
		}
	}

}
</script>

<style scoped lang="scss">
		
	.big-button {
		white-space: nowrap;
		.link {
			color: #f6ffff;
			font: 1.2rem/1.4 $font-condensed;
			font-weight: 600;
			letter-spacing: 0.05em;
			text-transform: uppercase;
			background-color: #5abfbe;
			transition: 0.2s all;
			user-select: none;
			display: inline-block;
		}
		&.current .link {
			background-color: lighten(#5abfbe, 20%);
		}
	}

	.pflege .big-button {
		.link {
			background-color: #80cae3;
		}
		&.current .link {
			background-color: lighten(#80cae3, 10%);
		}
	}

</style>
